module.exports = __webpack_public_path__ + "static/media/ca_4.d680ef7b.png";